import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function CorrectionProductForm() {
  return (
    <ArrayInput
      source="product_adjs"
      defaultValue={[{ product_id: undefined, amount: undefined }]}
    >
      <SimpleFormIterator
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth
        sx={{
          "& .RaSimpleFormIterator-action": {
            display: "flex",
            flexDirection: "column",
          },
          "& .RaSimpleFormIterator-action > .button-reorder": {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <FormDataConsumer>{(props) => <Inputs {...props} />}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
